module.exports = __webpack_public_path__ + "50a6226a37c4324d5ff51b12133fd276.png";